import React, { Component } from "react";
import classes from "./Activity.module.css";
import Aux from "../../hoc/Aux";
import SideDrawer from "../SideDrawer/SideDrawer";
import Header from "../../components/Header/Header";
import Body from "../Body/Body";

class Activity extends Component {
  state = {};

  componentDidMount = () => {
    console.log("componentMounted:Activity");
  };

  componentDidUpdate = () => {
    console.log("componentUpdated:Activity");
  };

  render() {
    return (
      <Aux>
        <div className={classes.Activity}>
          <SideDrawer></SideDrawer>
          <div className={classes.ActivityMain}>
            <Header></Header>
            <Body></Body>
          </div>
        </div>
      </Aux>
    );
  }
}

export default Activity;
